// extracted by mini-css-extract-plugin
export default {"bg":"Loading_bg__qpYU7","loader":"Loading_loader__rS1ky","rotate":"Loading_rotate__OpWKL"};